import React from 'react';

import { useSelector } from 'react-redux';

import GenericError from './GenericError';

const ErrorMessages = () => {
  const { type } = useSelector((state) => state.ui.errorStatus);

  const renderError = () => {
    switch (type) {
      case 'generic':
        return <GenericError />;
      default:
        return '';
    }
  };

  return (
    <div className="error-message">
      <div className="inner">
        {renderError()}
      </div>
    </div>
  );
};

export default ErrorMessages;
